import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setRenderLayout } from '../../reducers/BuildRenderRequestSlice';

export const LayoutSelector = () => {
  const dispatch = useDispatch();
  const { renderLayout } = useSelector((state: RootState) => state.buildRenderRequest);

  return (
    <div style={{ marginBottom: 10 }}>
      <span className="field-label">Render Layout</span>
      <div className="band-tabs">
        <button
          type="button"
          className={`band-tab${renderLayout !== 'Circular' ? ' active' : ''}`}
          onClick={() => dispatch(setRenderLayout('Linear'))}
        >
          Linear
        </button>
        <button
          type="button"
          className={`band-tab${renderLayout === 'Circular' ? ' active' : ''}`}
          onClick={() => dispatch(setRenderLayout('Circular'))}
        >
          Circular
        </button>
      </div>
    </div>
  );
};
